import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return (
			fg('saved_list_view_technical_changes_dogfooding') || fg('saved_list_view_merge_support')
		);
	},
};
